/**
 * Fold or unfold content
 */
class readMore extends HTMLElement {
  /**
   * connectedCallback
   */
  connectedCallback() {
    this.button = this.querySelector('[read-more-button]');
    this.button.addEventListener('click', () => {
      this.button.closest('[read-more-wrapper]').classList.toggle('collapsed');
    });
  }
}

customElements.define('read-more', readMore);
